<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="notice-list">
      <Title :jpn="t('お知らせ')" />
      <TabMenu class="tab-menu" :tabs="historyTabs" :activeTab="mode" @update-activeTab="changeMethod" />
      <NoticeTable v-if="mode === 1" :noticeList="dataNoticeList" @openDetail="handleDetail" />
      <NoticeTable v-if="mode === 2" :noticeList="importantNoticeList" @openDetail="handleDetail" />
    </div>
    <!--以下ダイアログ-->
    <div v-if="dialog" class="dialog-overlay" @click="dialog = false">
      <div class="dialog-content dialog-content-notice" @click.stop>
        <div class="header">
          <CloseButton :isThick="true" class="close" @handleClick="dialog = false" />
          <p class="content-title">{{ currentNotice.title }}</p>
        </div>
        <div class="content" >
          <p v-html="rtnContent(currentNotice.content, currentNotice.url)"></p>
          <!-- <p v-if="loading">loading...</p> -->
          <!-- <p v-else-if="detailData">{{ detailData.content }}</p> -->
          <!-- <p v-else-if="detailData">{{ rtnContent(currentNotice.content, currentNotice.url) }}</p> -->
          <!-- <p v-else>データが見つかりません</p> -->
          <!-- <div v-if="detailData.url" class="url"> {{ t('詳細はこちら') }} <a class="url" :href="detailData.url" target="_blank">{{ detailData.url }}</a></div> -->
        </div>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import Title from '@/components/molecules/Title02.vue';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import TabMenu from '@/components/molecules/TabMenu.vue';
import NoticeTable from '@/components/molecules/NoticeTable.vue';
import CloseButton from '@/components/atoms/CloseButton.vue';
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';

export default {
  mixins: [t],
  components: {
    BaseTemplate,
    Title,
    TabMenu,
    NoticeTable,
    CloseButton,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      noticeList: 'notice/noticeList',
      currentNotice: 'notice/currentNotice',
    }),
    dataNoticeList() {
      return this.noticeList?.list?.data ?? [];
    },
    importantNoticeList() {
      return this.noticeList?.list?.important ?? [];
    },
    detailData() {
      return this.$store.state.notice.currentNotice ?? null;
    },
    historyTabs() {
      return [
        { id: 1, label: this.t('クーポン') },
        { id: 2, label: this.t('お知らせ') },
      ];
    },
    // rtnContent(content, url) {
    //   // return this.$store.state.notice.currentNotice;
    //   // {url} の文字を含む場合は、urlをaタグに変換する
    //   // const urlRegex = /{url}/g;
    //   // const urlTag = `<a href="${url}" target="_blank">${url}</a>`;
    //   // const contentWithUrl = content.replace(urlRegex, urlTag);
    //   // // {url} の文字を含まない場合は、contentをそのまま返す
    //   // return contentWithUrl;
    //   console.log('content', content);
    //   console.log('url', url);
    // },
  },

  data: () => ({
    pageNumber: 1,
    mode: 1,
    dialog: false,
    loading: false,
    // currentNotice: null,
  }),

  watch: {
    currentNotice(newVal) {
      if (newVal) {
        this.dialog = true;
      }
    },
  },

  methods: {
    handleDetail(item) {
      this.$store.dispatch('notice/setNoticeDetail', { noticeId: item.id });
    },
    changeMethod(id) {
      this.mode = id;
    },
    rtnContent(content, url) {
      return content.replace(/{url}/g, `<a href="${url}" target="_blank">${url}</a>`);
    },
  },

  created() {
    const postParams = {};
    // const postParams = {
    //   important_flg: '1',
    // };
    const { pageNumber } = this;
    this.$store.dispatch('notice/setNoticeList', { pageNumber, postParams });
    if (this.currentUser.is_notice) {
      this.$store.dispatch('user/setConfirmNotice', true);
    }
  },
};
</script>

<style lang="scss" scoped>
.notice-list {
  width: 100%;
  max-width: 700px;
  padding: 0px 5px 30px;
  margin: 0px auto;
}
.tab-menu {
  margin-top: 7px;
}
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 19px;
  z-index: 9999;
  @media screen and  (max-width: $tabletWidth) {
    font-size:15px
  }
  .dialog-content {
    position: relative;
    // border: 1px solid #333366;
    box-shadow: 9px 9px 10px rgba(0, 0, 0, 1.5);
    background: white;
    width: 80%;
    height: 80%;
    max-width: 500px;
    z-index: 9999;
    text-align: center;
    word-wrap: break-word;
    flex-direction: column;
    overflow: hidden;
    border-radius: 20px;
    .content-title{
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      word-break: break-word;
      overflow-wrap: break-word;
      white-space: normal;
      font-size: 19px;
      padding: 20px 5px 0 5px;
      justify-content: center;
    }
    .header{
      position: sticky;
      top: 0;
      min-height: 50px;
      height: auto;
      background: white;
      z-index: 1000;
      display: flex;
      justify-content:center;
      // border-bottom: 1px solid #ddd;
    }
    .close {
      width: auto;
      height: auto;
      position: absolute;
      top: 20px;
      right: 9px;
      cursor: pointer;
    }
    .content {
      padding: 10px 30px 20px 30px;
      white-space: pre-wrap;
      word-break: break-word;
      max-width: 100%;
      flex-grow: 1; /* 残りの領域を占める */
      overflow-y: auto; /* スクロールを有効化 */
      max-height: calc(100% - 50px);
      overflow-wrap: break-word;
      text-align: left;
      font-size: 16px;
      color: $gray2;
      @media screen and  (max-width: $mobileWidth) {
        font-size: 14px;
      }
      // .url{
      //   margin-bottom: 30px;
      // }
    }
    .content-title{
      margin: 12px 0;
    }
  }
}

</style>

<style lang="scss">
.dialog-content-notice {
  .content {
    p {
      a {
        color: $blue !important;
        text-decoration: underline;
        &:hover {
          color: #2b1c8d !important;
        }
      }
    }
  }
}
</style>
